import React, { Fragment } from 'react'

const highlightedText = (label: string, textToHighlight: string | undefined) => {
  if (!textToHighlight) return label
  const highlighted: string = textToHighlight.toString()

  try {
    const regexp = new RegExp(highlighted, 'ig')
    const matches: RegExpMatchArray | null = label.match(regexp)
    if (!matches) return label

    const parts: string[] | React.JSX.Element[] = label.split(new RegExp(highlighted, 'ig'))
    if (parts[0] === '' && parts[1] === '') parts.pop()

    return parts.map((part, index) => (
      <Fragment key={index}>
        {part}
        {matches[index] && <span className='font-highlight'>{matches[index]}</span>}
      </Fragment>
    ))
  } catch {
    return label
  }
}

export default highlightedText
